export default {
  hero: {
    badge: 'Sadarbības Iespēja',
    title: 'Kļūstiet Par Mūsu Partneri',
    subtitle: 'Kopā ar The Daeg International Trade - Veidojiet Veiksmīgu Karjeru',
    description: 'Mēs meklējam stratēģiskos partnerus, lai paplašinātu biznesa tīklu Āzijā un Eiropā. Pievienojieties mums, lai radītu ilgtspējīgu vērtību un attīstītos kopā.',
    stats: {
      commission: { value: 'Piedāvājumi', label: 'Komisija' },
      support: { value: '100%', label: 'Atbalsts' },
      experience: { value: '5+', label: 'Gadu Pieredze' },
    },
    ctaPrimary: 'Reģistrēties Sadarbībai Tagad',
    ctaSecondary: 'Uzzināt Par Ieguvumiem',
  },
  intro: {
    title: 'Sadarbības Iespēja',
    heading: 'Paplašiniet Pakalpojumus, Palieliniet Ieņēmumus Kopā ar The Daeg',
    description1: 'The Daeg International Trade meklē stratēģiskos partnerus, lai paplašinātu biznesa tīklu Āzijā un Eiropā. Ar vairāk nekā 5 gadu pieredzi importa-eksporta un starptautisko investīciju jomā, mēs esam izveidojuši stabilu pamatu un esam gatavi dalīties panākumos ar partneriem.',
    description2: 'Mēs piedāvājam pievilcīgas sadarbības iespējas ar skaidriem ieguvumiem, profesionālu atbalstu un ilgtspējīgas attīstības potenciālu.',
    badge: 'Pieredze',
    badgeValue: '5+ Gadi',
  },
  benefits: {
    title: 'Sadarbības Ieguvumi',
    badge: 'Ieguvumi',
    subtitle: 'Mēs apņemamies sniegt reālu vērtību partneriem ar visaptverošu atbalsta politiku',
    items: [
      { title: 'Pievilcīga Komisija', description: 'Saņemiet konkurētspējīgu komisiju no katras veiksmīgas darījuma' },
      { title: 'Profesionāls Atbalsts', description: 'Saņemiet pilnu atbalstu no mūsu ekspertu komandas' },
      { title: 'Kvalitatīvi Produkti', description: 'Piekļūstiet kvalitatīviem produktiem un pakalpojumiem no The Daeg' },
      { title: 'Apmācība un Attīstība', description: 'Regulāras apmācības programmas profesionālo prasmju uzlabošanai' },
      { title: 'Mārketinga Atbalsts', description: 'Mārketinga materiāli un pārdošanas atbalsta rīki tiek nodrošināti' },
      { title: 'Ilgtermiņa Sadarbība', description: 'Veidojiet ilgtspējīgas partnerattiecības, attīstieties kopā' },
    ],
  },
  target: {
    title: 'Mēs Meklējam',
    badge: 'Mērķauditorija',
    subtitle: 'Mēs atzinīgi vērtējam sadarbību ar organizācijām un indivīdiem ar kopīgu attīstības vīziju',
    items: [
      { title: 'Imigrācijas Konsultanti', description: 'Pieredzējuši konsultanti imigrācijas un starptautisko investīciju jomā' },
      { title: 'Nekustamā Īpašuma Brokeri', description: 'Nekustamā īpašuma brokeri ar plašu klientu tīklu' },
      { title: 'Finanšu Konsultanti', description: 'Finanšu eksperti ar zināšanām par starptautiskajām investīcijām' },
      { title: 'Biznesa Organizācijas', description: 'Organizācijas, uzņēmumi, kas vēlas paplašināt pakalpojumus' },
    ],
  },
  whyPartner: {
    title: 'Kāpēc Sadarboties ar Mums',
    badge: 'Stiprās Puses',
    subtitle: 'Iemesli, kāpēc Latvijas uzturēšanās investīciju programma caur The Daeg ir galvenā izvēle',
    items: [
      { title: 'Uzticams Zīmols', description: 'The Daeg International Trade - Uzticams zīmols ar 5+ gadu pieredzi' },
      { title: 'Reāls Bizness', description: 'Īpašnieks Asian Alley veikalu ķēdei ar stabiliem ieņēmumiem' },
      { title: 'Augsts Panākumu Līmenis', description: '98% panākumu līmenis Latvijas uzturēšanās lietās' },
      { title: 'Profesionāls Process', description: 'Skaidrs, pārredzams process ar juridiskās komandas atbalstu' },
      { title: 'Saprātīga Investīcija', description: 'Investīcija no €50,000 — daudz zemāka nekā Golden Visa programmās Portugālē, Grieķijā vai Spānijā.' },
      { title: 'Eiropas Uzturēšanās Karte', description: 'Investori saņem Latvijas Uzturēšanās Karti, brīvi ceļo 27 Šengenas valstīs, atverot Eiropas durvis visai ģimenei.' },
      { title: 'Ātra Apstrāde', description: 'Ātra izskatīšanas procedūra, parasti tikai 2-4 mēneši. Nav ilgas gaidīšanas kā citās programmās.' },
      { title: 'Izaugsmes Potenciāls', description: 'Āzijas pārtikas tirgus Baltijā strauji aug. Investori ne tikai saņem uzturēšanās karti, bet arī peļņu no biznesa.' },
    ],
  },
  process: {
    title: 'Sadarbības Process',
    badge: 'Process',
    heading: 'Sāciet Sadarbību Tikai ar 4 Soļiem',
    subtitle: 'Vienkāršs, ātrs process, lai kļūtu par oficiālu The Daeg partneri',
    steps: [
      { title: 'Reģistrēt Interesi', description: 'Aizpildiet sadarbības reģistrācijas formu' },
      { title: 'Tikšanās un Apspriešana', description: 'Tikšanās, lai apspriestu sadarbības iespējas' },
      { title: 'Līguma Parakstīšana', description: 'Parakstīt sadarbības līgumu' },
      { title: 'Apmācība', description: 'Piedalīties apmācības programmā' },
      { title: 'Sākt Sadarbību', description: 'Sākt sadarbības darbības' },
    ],
  },
  form: {
    badge: 'Sadarbības Kontakts',
    title: 'Gatavi Kļūt Par Partneri?',
    description: 'Aizpildiet informāciju blakus, lai reģistrētos sadarbībai. Mūsu komanda sazināsies 24 stundu laikā, lai apspriestu programmas detaļas.',
    formTitle: 'Reģistrēties Sadarbībai',
    contact: {
      hotlineLabel: 'Sadarbības Tālrunis',
      emailLabel: 'Sadarbības E-pasts',
      addressLabel: 'Galvenais Birojs',
    },
    commitment: {
      badge: 'Mūsu Apņemšanās',
      quote: '"Mēs ne tikai meklējam biznesa partnerus, bet meklējam ceļabiedrus ar kopīgu vīziju — veidot tiltu starp Vjetnamu un Eiropu, sniedzot reālas iespējas katrai ģimenei."',
    },
    labels: {
      companyName: 'Uzņēmuma / Organizācijas Nosaukums',
      contactPerson: 'Kontaktpersona',
      phone: 'Tālruņa Numurs',
      email: 'E-pasts',
      website: 'Tīmekļa Vietne',
      experience: 'Uzturēšanās Pieredze',
      message: 'Ziņojums',
    },
    placeholders: {
      companyName: 'Ievadiet uzņēmuma nosaukumu',
      contactPerson: 'Vārds un uzvārds',
      phone: 'Tālruņa numurs',
      email: 'Kontakta e-pasts',
      website: 'https://...',
      experience: 'Izvēlieties pieredzi',
      message: 'Dalieties vairāk par savu organizāciju (maksimums 500 rakstzīmes)',
    },
    experienceOptions: ['Mazāk par 1 gadu', '1 - 3 gadi', '3 - 5 gadi', 'Vairāk par 5 gadiem'],
    required: '*',
    charCount: 'rakstzīmes',
    submit: 'Nosūtīt Sadarbības Reģistrāciju',
    submitting: 'Nosūta...',
    success: 'Sadarbības reģistrācija veiksmīga! Mēs sazināsimies ar jums 24 stundu laikā.',
    error: 'Radās kļūda. Lūdzu, mēģiniet vēlreiz vēlāk.',
  },
} as const;